/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
  text-align: left;
}

:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  font-size: calc(14rem/14);
  line-height: 3.143rem;
  margin: calc(8rem/14) 0;
  text-align: left;
}
:host :focus {
  outline: none;
}
:host > div.inputwrapper {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-direction: row;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
          justify-content: flex-start;
  align-content: flex-start;
  -webkit-box-align: start;
          align-items: flex-start;
  border: 1px solid var(--davinci-color-text-disabled,#8999A4);
  background-color: #FFFFFF;
  background-color: var(--davinci-color-white, #FFFFFF);
  line-height: 3.143rem;
}
:host > div.inputwrapper label.placeholder,
:host > div.inputwrapper label.label {
  -webkit-transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute;
  left: 0;
  padding: 0 calc(15rem/14);
  top: 0;
  color: #697987;
  color: var(--davinci-color-text-lighter, #697987);
  font-size: 1rem;
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  white-space: nowrap;
  line-height: 3.143rem;
}
:host > div.inputwrapper div.input {
  position: relative;
  height: inherit;
  -webkit-box-ordinal-group: 1;
          order: 0;
  -webkit-box-flex: 1;
          flex: 1 1 auto;
  align-self: auto;
  height: 3.143rem;
}
:host > div.inputwrapper div.input input {
  position: relative;
  font-size: inherit;
  height: 3.143rem;
  border: 0;
  padding: 0 calc(15rem/14);
  background: transparent;
  line-height: 1.57;
  width: 100%;
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
}
:host > div.inputwrapper div.input input::-ms-clear {
  display: none;
}
:host > div.inputwrapper slot {
  -webkit-box-ordinal-group: 1;
          order: 0;
  -webkit-box-flex: 0;
          flex: 0 0 auto;
  align-self: auto;
  padding: 0 calc(15rem/14) 0 0;
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
}
:host div.inputwrapper.focus-within {
  -webkit-transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid var(--davinci-color-primary,#007CC1) !important;
}
:host div.inputwrapper.focus-within label.label {
  -webkit-transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--davinci-color-primary,#007CC1) !important;
}
:host div.inputwrapper.focus-within + .message {
  visibility: hidden;
}
:host .message {
  margin-top: calc(4rem/14);
  min-height: calc(18rem/14);
}
:host .message .warning, :host .message .error {
  font-size: 1rem;
  line-height: calc(18rem/14);
  text-align: left;
}
:host .message .warning {
  display: none;
  color: #F5C413;
  color: var(--davinci-color-warning, #F5C413);
}
:host .message .error {
  display: none;
  color: #EA0823;
  color: var(--davinci-color-error, #EA0823);
}

:host([type=date]) > div.inputwrapper label.label,
:host([placeholder]) > div.inputwrapper label.label,
:host > div.inputwrapper.selected > label.label,
:host > div.inputwrapper.notempty > label.label {
  top: -0.5714rem;
  padding: 0 calc(5rem/14);
  line-height: calc(18rem/14);
  left: calc(10rem/14);
  background-color: #FFFFFF;
  background-color: var(--davinci-color-white, #FFFFFF);
  font-size: 85.71%;
  font-weight: 600;
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
  max-width: 90%;
}

:host([label=""]) > div.inputwrapper label.label,
:host(:not([label])) > div.inputwrapper label.label {
  display: none;
}

:host(:not([placeholder])) > div.inputwrapper label.placeholder,
:host([placeholder=""]) > div.inputwrapper label.placeholder,
:host([placeholder]) > div.inputwrapper.notempty label.placeholder {
  display: none;
}

:host([warning][placeholder]) div.inputwrapper label.label {
  color: #F5C413;
  color: var(--davinci-color-warning, #F5C413);
}

:host([warning]) div.inputwrapper {
  border: 1px solid var(--davinci-color-warning,#F5C413);
}
:host([warning]) div.inputwrapper.selected label.label,
:host([warning]) div.inputwrapper.notempty label.label {
  color: #F5C413;
  color: var(--davinci-color-warning, #F5C413);
}
:host([warning]) .message .error {
  display: none;
}
:host([warning]) .message .warning {
  display: block;
}

:host([error][placeholder]) div.inputwrapper label.label {
  color: #EA0823;
  color: var(--davinci-color-error, #EA0823);
}

:host([error]) div.inputwrapper {
  border: 1px solid var(--davinci-color-error,#EA0823);
}
:host([error]) div.inputwrapper.selected label.label,
:host([error]) div.inputwrapper.notempty label.label {
  color: #EA0823;
  color: var(--davinci-color-error, #EA0823);
}
:host([error]) .message .warning {
  display: none;
}
:host([error]) .message .error {
  display: block;
}

:host([readonly]) {
  pointer-events: none;
}
:host([readonly]) > div.inputwrapper > div.input > input {
  color: #505F6B;
  color: var(--davinci-color-text-light, #505F6B);
}

:host([disabled]) {
  pointer-events: none;
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
}
:host([disabled]) > div.inputwrapper {
  border: 1px solid var(--davinci-color-outline-disabled,#D2D9DD);
}
:host([disabled]) > div.inputwrapper > div.input > label.label,
:host([disabled]) > div.inputwrapper > div.input > label.placeholder {
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
}
:host([disabled]) > div.inputwrapper > div.input > input {
  color: inherit;
}`;
export { style };
//# sourceMappingURL=TextField.style.js.map